import React from "react";
import { slugifyHeading } from "@/components/LegalToc";

// Escape raw HTML first so user/admin content can't inject markup; we then
// re-introduce only the tags we generate ourselves (<strong>).
const escapeHtml = (s) =>
  s.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const inline = (s) => escapeHtml(s).replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");

// Minimal markdown renderer — headings, lists, paragraphs, bold. Shared by the
// public legal pages and the admin live-preview editor.
export const renderMarkdown = (md) => {
  if (!md) return null;
  const lines = md.split("\n");
  const out = [];
  let listBuf = [];
  const flushList = () => {
    if (listBuf.length) {
      out.push(<ul key={`ul-${out.length}`} className="md-legal-list">{listBuf.map((l, i) => <li key={`li-${out.length}-${i}-${l.slice(0, 16)}`} dangerouslySetInnerHTML={{ __html: l }} />)}</ul>);
      listBuf = [];
    }
  };
  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();
    if (!line) { flushList(); continue; }
    if (line.startsWith("# ")) { flushList(); out.push(<h1 key={i} className="md-legal-h1">{line.slice(2)}</h1>); continue; }
    if (line.startsWith("## ")) { flushList(); const text = line.slice(3); out.push(<h2 key={i} id={slugifyHeading(text)} className="md-legal-h2">{text}</h2>); continue; }
    if (line.startsWith("### ")) { flushList(); out.push(<h3 key={i} className="md-legal-h3">{line.slice(4)}</h3>); continue; }
    if (line.startsWith("- ")) {
      listBuf.push(inline(line.slice(2)));
      continue;
    }
    flushList();
    out.push(<p key={i} className="md-legal-p" dangerouslySetInnerHTML={{ __html: inline(line) }} />);
  }
  flushList();
  return out;
};
